import {
  Button,
  Container,
  IconButton,
  Layout,
  Spacer,
  SvgClose,
  Text,
  Tooltip,
} from '@loomhq/lens';
import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showErrorBar } from 'actions/errorBar';
import { ERROR } from 'constants/error-severities';
import { declinePendingWorkspaceInvite } from 'creators/workspace';
import * as sentry from 'utilities/sentry';
import {
  goToWorkspace,
  requestAcceptWorkspaceInvite,
} from 'utilities/workspace';

import { selectCurrentUser } from 'selectors/user';

import WorkspaceLogo from 'components/workspace-logo';

import styles from './styles.module.less';

const PendingInvites = ({ hideSections = false, showLogos = false }) => {
  const currentUser = useSelector(selectCurrentUser);
  const invites = useSelector(state => state.workspace.pendingInvites);

  const dispatch = useDispatch();

  const acceptInvite = async (token, workspaceId) => {
    try {
      await requestAcceptWorkspaceInvite(token);

      goToWorkspace(workspaceId);
    } catch (err) {
      dispatch(showErrorBar(ERROR, 'Error accepting workspace invitation'));
      sentry.logException(err, 'Error accepting workspace invitation');
    }
  };

  if (!invites.length) {
    return null;
  }

  return (
    <div
      className={
        hideSections
          ? null
          : classnames(
              styles.workspacesListSection,
              styles.workspacesListInvitesSection
            )
      }
    >
      <Spacer left="medium" right="medium" top="small" bottom="small">
        <Text fontWeight="medium">Pending Invitations</Text>
      </Spacer>
      {invites.map((invite, index) => {
        const { workspace } = invite;

        return (
          <Spacer
            top="small"
            bottom="small"
            left="medium"
            right="small"
            key={index}
          >
            <Layout gap="small" alignment="center">
              {showLogos && (
                <Layout.Section width="auto">
                  <WorkspaceLogo size={5} workspace={workspace} />
                </Layout.Section>
              )}
              <Layout.Section>
                <Text hasEllipsis fontWeight="bold">
                  {workspace.name}
                </Text>
                <Spacer></Spacer>
              </Layout.Section>
              <Layout.Section width="auto">
                <Tooltip
                  content={
                    currentUser.deletion_pending
                      ? 'This account will be deleted. Undo to accept invitation'
                      : null
                  }
                >
                  <Button
                    isDisabled={currentUser.deletion_pending}
                    onClick={() =>
                      acceptInvite(invite.token, invite.organization_id)
                    }
                  >
                    Join
                  </Button>
                </Tooltip>
              </Layout.Section>
              <Layout.Section width="auto">
                <Container height={4}>
                  <IconButton
                    altText="Decline"
                    icon={<SvgClose />}
                    onClick={() =>
                      dispatch(declinePendingWorkspaceInvite(invite.id))
                    }
                  />
                </Container>
              </Layout.Section>
            </Layout>
          </Spacer>
        );
      })}
    </div>
  );
};

export default PendingInvites;
